import Vue from 'vue'
import VueRouter from 'vue-router'
import {routes} from '../config/routeConfig'
import store from '@/store'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
})

export default router
router.beforeEach((to, from, next) => {
  let breadList=[];
  // console.log(to)
  // console.log(from)
  if(to.path=='/list'){
    if(from.path=='/detail'){
      breadList[0]=to.query.meunname
      if(to.query.type){
        breadList[1]=to.query.type
        store.commit('UPD_BREADLIST',breadList);
      }
    }else{
      breadList[0]=to.query.meunname
      if(to.query.type){
        breadList[1]=to.query.type
        store.commit('UPD_BREADLIST',breadList);
      }
    }
  }
  if(to.path=='/detail'){
    if(from.path=='/list'){
      breadList[0]=from.query.meunname
      if(to.query.type){
        breadList[1]=to.query.type;
      }
      if(to.query.title){
        breadList[2]=to.query.title;
      }
      store.commit('UPD_BREADLIST',breadList);
    }else{
      breadList[0]=from.meta.title
      if(to.query.type){
        breadList[1]=to.query.type;
      }
      if(to.query.title){
        breadList[2]=to.query.title;
      }
      store.commit('UPD_BREADLIST',breadList);
    }
  }
  next();
});
//vue路由重复点击报错的解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
